<template>
  <div class="admin-tags">
    <div class="page-header">
      <h2 class="page-title">标签管理</h2>
      <el-button type="primary" icon="el-icon-plus" @click="showAddDialog">新建标签</el-button>
    </div>

    <el-table :data="tags" v-loading="loading" stripe>
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="slug" label="Slug" />
      <el-table-column label="颜色" width="80">
        <template slot-scope="scope">
          <span class="color-dot" :style="{ background: scope.row.color }"></span>
          {{ scope.row.color }}
        </template>
      </el-table-column>
      <el-table-column prop="article_count" label="文章数" width="80" />
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteTag(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="400px">
      <el-form :model="form" label-position="top">
        <el-form-item label="名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="Slug">
          <el-input v-model="form.slug" />
        </el-form-item>
        <el-form-item label="颜色">
          <el-color-picker v-model="form.color" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTag">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { adminApi, frontApi } from '../../utils/api'

export default {
  name: 'AdminTags',
  data() {
    return {
      tags: [],
      loading: false,
      dialogVisible: false,
      isEdit: false,
      editId: null,
      form: { name: '', slug: '', color: '#409EFF' }
    }
  },
  computed: {
    dialogTitle() { return this.isEdit ? '编辑标签' : '新建标签' }
  },
  created() {
    this.loadTags()
  },
  methods: {
    async loadTags() {
      this.loading = true
      try {
        const res = await frontApi.getTags()
        this.tags = res.tags || []
      } catch (e) { console.error(e) }
      this.loading = false
    },
    showAddDialog() {
      this.isEdit = false
      this.form = { name: '', slug: '', color: '#409EFF' }
      this.dialogVisible = true
    },
    showEditDialog(row) {
      this.isEdit = true
      this.editId = row.id
      this.form = { name: row.name, slug: row.slug, color: row.color }
      this.dialogVisible = true
    },
    async saveTag() {
      try {
        if (this.isEdit) {
          await adminApi.updateTag(this.editId, this.form)
          this.$message.success('标签更新成功')
        } else {
          await adminApi.createTag(this.form)
          this.$message.success('标签创建成功')
        }
        this.dialogVisible = false
        this.loadTags()
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    async deleteTag(row) {
      try {
        await this.$confirm(`确定删除标签「${row.name}」？`, '确认', { type: 'warning' })
        await adminApi.deleteTag(row.id)
        this.$message.success('删除成功')
        this.loadTags()
      } catch (e) {
        if (e !== 'cancel') this.$message.error('删除失败')
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
}
.color-dot {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 4px;
}
</style>
